import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';  // This is your current App.js content
import ExecutiveTalent from './pages/ExecutiveTalent';
import AIAutomation from './pages/AIAutomation';
import DigitalAgency from './pages/DigitalAgency';
import Contact from './components/Contact';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <ScrollToTop /> 
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />  {/* This is your main home page */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/executive-talent" element={<ExecutiveTalent />} />
          <Route path="/ai-automation" element={<AIAutomation />} />
          <Route path="/digital-agency" element={<DigitalAgency />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;